import { render, staticRenderFns } from "./allProduct.vue?vue&type=template&id=dde60362&"
import script from "./allProduct.vue?vue&type=script&lang=js&"
export * from "./allProduct.vue?vue&type=script&lang=js&"
import style0 from "./allProduct.vue?vue&type=style&index=0&id=dde60362&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports